/* eslint-disable no-underscore-dangle */
import _ from 'lodash';
import { all } from 'redux-saga/effects';
import { sagaMiddleware } from './createStore';

import reducer from './reducer';

// создает элемент набора редьюсеров и саг
export const createCombineMapItem = (
  name,
  reducerCreateFunction,
  sagasCreateFunctions
) => [
  {
    name,
    createReduceFunc: reducerCreateFunction,
    createSagasFunc: sagasCreateFunctions
  }
];

export class ReducerRegistry {
  constructor() {
    this._emitChange = null;
    this._reducers = reducer;
    this._sagas = {};
  }

  getReducers() {
    return { ...this._reducers };
  }

  /**
   * Динамическое добавление нового reducer в store
   */
  register(name, reducerObj, saga = null) {
    if (!_.get(this._reducers, name)) {
      // console.log(name);
      const newReducer = name
        .split('.')
        .reduceRight(
          (acc, currentValue) => ({ [currentValue]: acc }),
          reducerObj
        );
      this._reducers = _.merge(this._reducers, newReducer);
      if (saga !== null && !this._sagas[name]) {
        this._sagas[name] = true;
        if (Array.isArray(saga)) {
          saga.map(itemSaga => sagaMiddleware.run(itemSaga, name));
        } else {
          sagaMiddleware.run(saga, name);
        }
      }
      if (this._emitChange) {
        this._emitChange(this.getReducers());
      }
    }
  }

  /**
   * Регистрация нового reducer из набора
   */
  // eslint-disable-next-line class-methods-use-this
  constructReduceFromMap(combineName, combineMap) {
    const result = {
      combine: {},
      sagas: []
    };
    /* console.log(`${combineName} ${typeof combineMap}`);
    console.log(_.isArray(combineMap));
    console.log(combineMap); */
    if (typeof combineMap === 'object' && !_.isArray(combineMap)) {
      Object.keys(combineMap).map(treeName => {
        const child = this.constructReduceFromMap(
          `${combineName}.${treeName}`,
          combineMap[treeName]
        );
        result.combine[treeName] = child.combine;
        result.sagas = [...result.sagas, ...child.sagas];
        return null;
      });
    } else {
      combineMap.map(item => {
        result.combine = {
          ...result.combine,
          ...item.createReduceFunc(combineName, item.name)
        };
        item.createSagasFunc.map(createSagaFunc => {
          result.sagas = [
            ...result.sagas,
            ...createSagaFunc(`${combineName}.${item.name}`)
          ];
          return null;
        });
        return null;
      });
    }
    return result;
  }

  registerByCombineMap(combineName, combineMap) {
    const result = this.constructReduceFromMap(combineName, combineMap);
    this.register(combineName, result.combine, function* createSaga() {
      yield all(result.sagas);
    });
  }

  setChangeListener(listener) {
    this._emitChange = listener;
  }
}

export const reducerRegistry = new ReducerRegistry();
export default reducerRegistry;



// WEBPACK FOOTER //
// ./src/mt-react-common/reducerRegistry.js